// @copyright  2025 - AI Employees Module Translation File

export default {
    '$dir': 'ltr',

    'ai_employee.term': 'Due on receipt | {count} days',

    'ai_employee.page.title': 'AI Employees',
    'ai_employee.page.search_results': 'Search Results',
    'ai_employee.page.create.title': 'New AI Employee',
    'ai_employee.page.search.title': 'Find AI Employees',
    'ai_employee.page.edit.title': 'Edit AI Employee',
    'ai_employee.page.view.title': 'View AI Employee',
    'ai_employee.page.tasks.title': 'AI Tasks',
    'ai_employee.page.all': 'All',

    'ai_employee.button.cancel': 'Cancel',
    'ai_employee.button.select': 'Select',
    'ai_employee.button.find': 'Find AI Employees',
    'ai_employee.button.search': 'Apply',
    'ai_employee.button.create': 'Save Changes',
    'ai_employee.button.save': 'Save Changes',
    'ai_employee.button.new': 'New AI Employee',
    'ai_employee.button.delete': 'Permanently Delete',
    'ai_employee.button.edit': 'Edit',
    'ai_employee.button.archive': 'Archive',
    'ai_employee.button.restore': 'Restore',
    'ai_employee.button.reset': 'Reset',
    'ai_employee.button.confirm': 'Confirm',
    'ai_employee.button.assign_task': 'Assign Task',
    'ai_employee.button.view_tasks': 'View Tasks',

    'ai_employee.placeholder.search': 'Search AI employees',
    'ai_employee.placeholder.search_items': 'Search employees',
    'ai_employee.placeholder.name': 'Enter employee name',
    'ai_employee.placeholder.type': 'Select employee type',
    'ai_employee.placeholder.description': 'Enter employee description',
    'ai_employee.placeholder.capabilities': 'Enter employee capabilities',

    'ai_employee.message.no_change': 'This AI employee has not changed since it was created.',
    'ai_employee.message.no_employees': 'No AI employees found',

    'ai_employee.link.create_first_ai_employee': 'Click here to create your first AI employee',
    'ai_employee.link.ai_employees': 'Return to AI Employees',
    'ai_employee.link.retry': 'Click here to retry',

    'ai_employee.checkbox.all': 'Check All',
    'ai_employee.checkbox.actions_label': 'with selected',

    'ai_employee.label.name': 'Name',
    'ai_employee.label.type': 'Type',
    'ai_employee.label.roles': 'Assigned Roles',
    'ai_employee.label.permissions': 'Permissions',
    'ai_employee.label.available_tools': 'Available Tools',
    'ai_employee.label.description': 'Description',
    'ai_employee.label.capabilities': 'Capabilities',
    'ai_employee.label.status': 'Status',
    'ai_employee.label.is_active': 'Active',
    'ai_employee.label.created_at': 'Created on',
    'ai_employee.label.updated_at': 'Last updated',
    'ai_employee.label.tasks_completed': 'Tasks Completed',
    'ai_employee.label.tasks_in_progress': 'Tasks In Progress',
    'ai_employee.label.total_tasks': 'Total Tasks',
    'ai_employee.label.performance_score': 'Performance Score',
    'ai_employee.label.specializations': 'Specializations',
    'ai_employee.label.availability': 'Availability',
    'ai_employee.label.no_items': 'No items found',
    'ai_employee.label.archive_reason': 'Reason for archiving AI employee',
    'ai_employee.label.delete_reason': 'Reason for deleting AI employee',

    'ai_employee.sort.field_label': 'Field',
    'ai_employee.sort.direction_label': 'Direction',
    'ai_employee.sort.direction_ascending': 'Ascending',
    'ai_employee.sort.direction_descending': 'Descending',

    'ai_employee.modal.title.ai_employee_archive': 'Archive AI Employee',
    'ai_employee.modal.title.ai_employee_delete': 'Delete AI Employee',
    'ai_employee.modal.title.ai_employee_restore': 'Restore AI Employee',
    'ai_employee.modal.title.assign_task': 'Assign Task to AI Employee',

    'ai_employee.modal.message.ai_employee_archive': 'Are you sure that you want to archive this AI employee? This action can be undone. | Are you sure that you want to archive these AI employees? This action can be undone.',
    'ai_employee.modal.message.ai_employee_delete': 'Are you sure that you want to permanently delete this AI employee? This action cannot be undone. | Are you sure that you want to permanently delete these AI employees? This action cannot be undone.',
    'ai_employee.modal.message.ai_employee_restore': 'Are you sure that you want to restore this AI employee? | Are you sure that you want to restore these AI employees?',

    'ai_employee.success.message.ai_employee_created': 'Your AI employee has been created',
    'ai_employee.success.message.ai_employee_updated': 'Your AI employee has been updated',
    'ai_employee.success.message.archived_ai_employees': 'Your AI employee has been archived | All selected AI employees were archived',
    'ai_employee.success.message.deleted_ai_employees': 'Your AI employee has been permanently deleted | All selected AI employees were permanently deleted',
    'ai_employee.success.message.restored_ai_employees': 'Your AI employee has been restored | All selected AI employees were restored',
    'ai_employee.success.message.task_assigned': 'Task has been assigned to the AI employee',

    'ai_employee.error.message.archived_ai_employees': 'This AI employee was already archived | These AI employees were already archived',
    'ai_employee.error.message.deleted_ai_employees': 'This AI employee was already deleted | These AI employees were already deleted',
    'ai_employee.error.message.restored_ai_employees': 'This AI employee was already restored | These AI employees were already restored',
    'ai_employee.error.message.error_loading_page': 'Sorry, there was an error loading AI employee. | Sorry, there was an error loading AI employees.',
    'ai_employee.error.message.task_assignment_failed': 'Failed to assign task to AI employee',

    // Task-related translations
    'ai_employee.task.status.pending': 'Pending',
    'ai_employee.task.status.in_progress': 'In Progress',
    'ai_employee.task.status.completed': 'Completed',
    'ai_employee.task.status.failed': 'Failed',
    'ai_employee.task.priority.low': 'Low',
    'ai_employee.task.priority.medium': 'Medium',
    'ai_employee.task.priority.high': 'High',
    'ai_employee.task.priority.critical': 'Critical',

    // Employee types
    'ai_employee.type.data_analyst': 'Data Analyst',
    'ai_employee.type.content_writer': 'Content Writer',
    'ai_employee.type.customer_support': 'Customer Support',
    'ai_employee.type.research_assistant': 'Research Assistant',
    'ai_employee.type.code_reviewer': 'Code Reviewer',
    'ai_employee.type.general': 'General Assistant',
    'ai_employee.type.data_processor': 'Data Processor',
    'ai_employee.type.validator': 'Validator',
    'ai_employee.type.report_generator': 'Report Generator',
    'ai_employee.type.developer': 'Developer',
    'ai_employee.type.analyst': 'Analyst',
    'ai_employee.type.writer': 'Writer',
    'ai_employee.type.designer': 'Designer',
    'ai_employee.type.researcher': 'Researcher',
    'ai_employee.type.support': 'Support',
    'ai_employee.type.custom': 'Custom',

    // Menu items
    'ai_employee.menu.all_employees': 'All Employees',
    'ai_employee.menu.active_employees': 'Active Employees',
    'ai_employee.menu.inactive_employees': 'Inactive Employees',
    'ai_employee.menu.archived_employees': 'Archived Employees',
    'ai_employee.menu.select_employees': 'Select Employees',
    'ai_employee.menu.all_tasks': 'All Tasks',

    // Actions
    'ai_employee.action.select_all': 'Select All',
    'ai_employee.action.deselect_all': 'Deselect All',

    // Search
    'ai_employee.search.title': 'Search AI Employees',
    'ai_employee.search.keyword': 'Keyword',
    'ai_employee.search.keyword_placeholder': 'Search by name or description',
    'ai_employee.search.all_types': 'All Types',
    'ai_employee.search.all_statuses': 'All Statuses',
    'ai_employee.search.all_priorities': 'All Priorities',
    'ai_employee.search.all_models': 'All Models',
    'ai_employee.search.all_employees': 'All Employees',
    'ai_employee.search.only_auto_assign': 'Only Auto-Assign',
    'ai_employee.search.created_date_range': 'Created Date Range',

    // Statuses
    'ai_employee.status.active': 'Active',
    'ai_employee.status.inactive': 'Inactive',

    // Task statuses
    'ai_employee.task_status.pending': 'Pending',
    'ai_employee.task_status.processing': 'Processing',
    'ai_employee.task_status.completed': 'Completed',
    'ai_employee.task_status.failed': 'Failed',
    'ai_employee.task_status.cancelled': 'Cancelled',
    'ai_employee.task_status.retrying': 'Retrying',

    // Priorities
    'ai_employee.priority.low': 'Low',
    'ai_employee.priority.normal': 'Normal',
    'ai_employee.priority.high': 'High',
    'ai_employee.priority.critical': 'Critical',

    // Sort options
    'ai_employee.sort.name_asc': 'Name (A-Z)',
    'ai_employee.sort.name_desc': 'Name (Z-A)',
    'ai_employee.sort.created_asc': 'Oldest First',
    'ai_employee.sort.created_desc': 'Newest First',
    'ai_employee.sort.updated_asc': 'Least Recently Updated',
    'ai_employee.sort.updated_desc': 'Most Recently Updated',
    'ai_employee.sort.priority_asc': 'Priority (Low to High)',
    'ai_employee.sort.priority_desc': 'Priority (High to Low)',

    // Additional labels
    'ai_employee.label.priority': 'Priority',
    'ai_employee.label.model': 'Model',
    'ai_employee.label.max_tokens': 'Max Tokens',
    'ai_employee.label.temperature': 'Temperature',
    'ai_employee.label.auto_assign_tasks': 'Auto Assign Tasks',
    'ai_employee.label.system_instructions': 'System Instructions',

    // Task-specific labels
    'ai_employee.task.details_title': 'Task Details',
    'ai_employee.task.title': 'Task Title',
    'ai_employee.task.status': 'Status',
    'ai_employee.task.title_placeholder': 'Enter a descriptive title for this task',
    'ai_employee.task.name': 'Task Title', // Deprecated: Use 'title' instead
    'ai_employee.task.name_placeholder': 'Enter a descriptive title for this task', // Deprecated
    'ai_employee.task.instructions': 'Instructions',
    'ai_employee.task.instructions_placeholder': 'Provide detailed instructions for the AI employee',
    'ai_employee.task.description': 'Instructions', // Deprecated: Use 'instructions' instead
    'ai_employee.task.description_placeholder': 'Provide detailed instructions for the AI employee', // Deprecated
    'ai_employee.task.type': 'Task Type', // Deprecated: task_type field removed
    'ai_employee.task.assigned_to': 'Assigned To',
    'ai_employee.task.created_at': 'Created At',
    'ai_employee.task.deadline': 'Deadline',
    'ai_employee.task.started_at': 'Started At',
    'ai_employee.task.completed_at': 'Completed At',
    'ai_employee.task.retry_count': 'Retry Count',
    'ai_employee.task.execution_time': 'Execution Time',
    'ai_employee.task.input_data': 'Input Data',
    'ai_employee.task.input_data_placeholder': 'Enter JSON input data (optional)',
    'ai_employee.task.input_data_help': 'Provide JSON-formatted data that the AI employee will use',
    'ai_employee.task.output_data': 'Output Data',
    'ai_employee.task.error_message': 'Error Message',
    'ai_employee.task.metadata': 'Metadata',
    'ai_employee.task.auto_start': 'Auto Start',
    'ai_employee.task.auto_start_help': 'Automatically start this task after assignment',
    'ai_employee.task.max_retries': 'Max Retries',
    'ai_employee.task.max_retries_help': 'Number of times to retry if the task fails',
    'ai_employee.task.assign_task_to': 'Assign Task to',
    'ai_employee.task.priority': 'Priority',
    'ai_employee.task.created': 'Created',
    'ai_employee.task.started': 'Started',
    'ai_employee.task.completed': 'Completed',
    'ai_employee.task.output': 'Output',
    'ai_employee.task.page.search.title': 'Find AI Tasks',
    'ai_employee.task.placeholder.search': 'Search tasks',
    'ai_employee.task.button.reset': 'Reset',
    'ai_employee.task.button.search': 'Apply',
    'ai_employee.task.sort.field_label': 'Field',
    'ai_employee.task.sort.direction_label': 'Direction',
    'ai_employee.task.sort.direction_ascending': 'Ascending',
    'ai_employee.task.sort.direction_descending': 'Descending',
    'ai_employee.task.label.task_type': 'Task Type',
    'ai_employee.task.label.assigned_employee': 'Assigned Employee',
    'ai_employee.task.filter.all_tasks': 'All Tasks',
    'ai_employee.task.filter.pending_tasks': 'Pending Tasks',
    'ai_employee.task.filter.processing_tasks': 'Processing Tasks',
    'ai_employee.task.filter.completed_tasks': 'Completed Tasks',
    'ai_employee.task.filter.failed_tasks': 'Failed Tasks',
    'ai_employee.task.filter.cancelled_tasks': 'Cancelled Tasks',

    // Task types
    'ai_employee.task_type.invoice_processing': 'Invoice Processing',
    'ai_employee.task_type.expense_processing': 'Expense Processing',
    'ai_employee.task_type.entity_search': 'Entity Search',
    'ai_employee.task_type.compliance_validation': 'Compliance Validation',
    'ai_employee.task_type.data_validation': 'Data Validation',
    'ai_employee.task_type.financial_report': 'Financial Report',
    'ai_employee.task_type.analytics_report': 'Analytics Report',

    // Sections
    'ai_employee.section.details': 'Details',
    'ai_employee.section.statistics': 'Statistics',
    'ai_employee.section.task_history': 'Task History',
    'ai_employee.section.configuration': 'Configuration',
    'ai_employee.section.settings': 'Settings',
    'ai_employee.section.metadata': 'Metadata',

    // Statistics
    'ai_employee.stats.total_tasks': 'Total Tasks',
    'ai_employee.stats.completed_tasks': 'Completed Tasks',
    'ai_employee.stats.pending_tasks': 'Pending Tasks',

    // Filter
    'ai_employee.filter.all_statuses': 'All Statuses',

    // Modal messages
    'ai_employee.modal.title.archive_employee': 'Archive AI Employee',
    'ai_employee.modal.message.archive_employee': 'Are you sure you want to archive this AI employee?',
    'ai_employee.modal.title.delete_employee': 'Delete AI Employee',
    'ai_employee.modal.message.delete_employee': 'Are you sure you want to permanently delete this AI employee? This action cannot be undone.',

    // Button labels for tasks
    'ai_employee.button.cancel_task': 'Cancel Task',
    'ai_employee.button.retry_task': 'Retry Task',
    'ai_employee.button.approve_plan': 'Approve Plan',

    // Confirm messages
    'ai_employee.confirm.cancel_task': 'Are you sure you want to cancel this task?',
    'ai_employee.confirm.retry_task': 'Are you sure you want to retry this task?',

    // Success messages for tasks
    'ai_employee.success.message.task_cancelled': 'Task has been cancelled successfully',
    'ai_employee.success.message.task_retried': 'Task has been retried successfully',
    'ai_employee.success.message.plan_approved': 'Plan approved. The AI will begin executing the task.',

    // Error messages for tasks
    'ai_employee.error.message.cancel_task_failed': 'Failed to cancel task',
    'ai_employee.error.message.retry_task_failed': 'Failed to retry task',
    'ai_employee.error.message.load_task_failed': 'Failed to load task details',
    'ai_employee.error.message.approve_plan_failed': 'Failed to approve plan',

    // Global labels (used across the app)
    'label.cancel_button': 'Cancel',
    'label.save_button': 'Save',
    'label.from': 'From',
    'label.to': 'To',
    'label.default': 'Default',
    'label.refresh': 'Refresh',
    'label.back_button': 'Back',
    'label.no_description': 'No description available',
    'label.no_instructions': 'No instructions available',
    'label.no_deadline': 'No deadline',
    'label.close': 'Close',
    'label.sort_by': 'Sort By',
    'label.created_at': 'Created At',
    'label.updated_at': 'Updated At',
    'label.show': 'Show',
    'label.hide': 'Hide',
    'label.loading': 'Loading',
    'label.yes': 'Yes',
    'label.no': 'No',
    'label.retry': 'Retry',

    // Validation messages
    'ai_employee.validation.name_required': 'Name is required',
    'ai_employee.validation.task_title_required': 'Task title is required',
    'ai_employee.validation.task_name_required': 'Task title is required', // Deprecated: Use task_title_required
    'ai_employee.validation.task_instructions_required': 'Task instructions are required',
    'ai_employee.validation.task_description_required': 'Task instructions are required', // Deprecated: Use task_instructions_required
    'ai_employee.validation.task_type_required': 'Task type is required', // Deprecated: task_type field removed
    'ai_employee.validation.type_required': 'Type is required',
    'ai_employee.validation.roles_required': 'Please select at least one role',
    'ai_employee.validation.max_tokens_range': 'Max tokens must be between 100 and 100,000',
    'ai_employee.validation.temperature_range': 'Temperature must be between 0 and 1',
    'ai_employee.validation.invalid_json': 'Invalid JSON format',

    // Help text
    'ai_employee.help.roles': 'Select one or more roles to define what this AI Employee can do',
    'ai_employee.help.tools_based_on_roles': 'These tools are automatically available based on the selected roles',
    'ai_employee.help.capabilities': 'Enter the specific capabilities this employee will have',
    'ai_employee.help.is_active': 'Inactive employees will not process any tasks',
    'ai_employee.help.auto_assign_tasks': 'Automatically assign compatible tasks to this employee',
    'ai_employee.help.priority': 'Higher priority employees will receive tasks first',
    'ai_employee.help.system_instructions': 'Custom instructions that guide the AI employee behavior',
    'ai_employee.help.temperature': 'Higher values make the output more random, lower values more deterministic',

    // Error messages for roles
    'ai_employee.error.message.failed_to_load_roles': 'Failed to load available roles. Please try again.',
    'ai_employee.error.message.failed_to_load_permissions': 'Failed to load role permissions. Please try again.',
    'ai_employee.error.message.role_not_in_plan': 'Selected role is not available in your current plan',
    'ai_employee.error.message.unauthorized_role': 'You do not have access to assign this role. Please upgrade your plan or contact support.',
    'ai_employee.error.message.loading_ai_employee': 'Failed to load AI Employee details',
    'ai_employee.error.message.load_employees_failed': 'Failed to load AI employees. Please try again.',
    'ai_employee.error.message.task': 'Error',

    // Empty states
    'ai_employee.empty.no_tasks': 'No tasks found',
    'ai_employee.empty.no_roles': 'No roles available for your plan',

    // Loading states
    'ai_employee.loading.tasks': 'Loading tasks...',
    'ai_employee.loading.roles': 'Loading available roles...',
    'ai_employee.loading.permissions': 'Loading permissions...',

    // Page titles
    'ai_employee.page.update.title': 'Update AI Employee',

    // Placeholders
    'ai_employee.placeholder.max_tokens': '4096',
    'ai_employee.placeholder.temperature': '0.7',
    'ai_employee.placeholder.system_instructions': 'You are a helpful AI assistant...',

    // Task Approval Modal
    'ai_employee.modal.task_approval.title': 'Review & Approve Plan',
    'ai_employee.modal.task_approval.summary': 'Summary',
    'ai_employee.modal.task_approval.steps': 'Steps',
    'ai_employee.modal.task_approval.step': 'Step {n}',
    'ai_employee.modal.task_approval.risks': 'Risks',
    'ai_employee.modal.task_approval.no_steps': 'The AI did not propose any steps. Send another message to refine the plan.',
    'ai_employee.modal.task_approval.placeholder.summary': 'Brief summary of what will be done...',
    'ai_employee.modal.task_approval.placeholder.step_title': 'Step title...',
    'ai_employee.modal.task_approval.placeholder.step_description': 'What happens in this step...',
    'ai_employee.modal.task_approval.placeholder.risk': 'Risk {n}...',
    'ai_employee.modal.task_approval.button.approve': 'Approve Plan',
    'ai_employee.modal.task_approval.button.approving': 'Approving...',
    'ai_employee.modal.task_approval.button.cancel': 'Cancel',
    'ai_employee.modal.task_approval.button.add_risk': 'Add risk',
    'ai_employee.modal.task_approval.button.remove_risk': 'Remove risk',
    'ai_employee.modal.task_approval.label.tool': 'Tool',
    'ai_employee.modal.task_approval.label.title': 'Title',
    'ai_employee.modal.task_approval.label.description': 'Description',
    'ai_employee.modal.task_approval.label.requires_approval': 'Requires explicit approval at runtime',
    'ai_employee.error.message.extract_plan_failed': 'Failed to extract plan from conversation',
    'ai_employee.error.message.approve_plan_retry': 'Failed to approve plan. Please try again.',

    // Conversation list
    'ai_employee.conversation.default_assistant_name': 'AI Agent',
    'ai_employee.conversation.default_user_name': 'User',
    'ai_employee.conversation.empty': 'No messages yet.',
    'ai_employee.conversation.avatar.assistant': 'AI',
    'ai_employee.conversation.avatar.user': 'U',

    // Execution history panel
    'ai_employee.execution_history.title': 'Execution History',
    'ai_employee.execution_history.run_count': '{count} run | {count} runs',
    'ai_employee.execution_history.empty': 'No executions yet.',
    'ai_employee.execution_history.run_label': 'Run #{count}',
    'ai_employee.execution_history.finished_label': 'finished {time}',
    'ai_employee.execution_history.view_conversation': 'View conversation',
    'ai_employee.execution_history.hide_conversation': 'Hide conversation',
    'ai_employee.execution_history.no_conversation': 'No conversation',
    'ai_employee.execution_history.no_conversation_recorded': 'No conversation recorded for this run.',
    'ai_employee.execution_history.error.load_failed': 'Failed to load execution history.',
    'ai_employee.execution_history.error.load_conversation_failed': 'Failed to load conversation.',

    // Task detail page
    'ai_employee.task_page.button.review_and_approve_plan': 'Review & Approve Plan',
    'ai_employee.task_page.button.view_approved_plan': 'View Approved Plan',
    'ai_employee.task_page.button.send': 'Send',
    'ai_employee.task_page.placeholder.input_planning': 'Describe what you want the AI to do, ask questions, or provide requirements...',
    'ai_employee.task_page.placeholder.input_executing': 'Provide guidance or ask for status updates...',
    'ai_employee.task_page.conversation.empty': 'Start the conversation by describing what you want the AI to do',
    'ai_employee.task_page.state.plan_approved': 'plan approved',
    'ai_employee.task_page.state.planning': 'planning',
    'ai_employee.task_page.streaming.thinking': 'thinking...',
    'ai_employee.task_page.streaming.typing': 'typing...',
    'ai_employee.task_page.streaming.using_tool': 'Using tool: {tool}…',
    'ai_employee.task_page.streaming.no_response': "The assistant didn't return a response. Please try again.",
    'ai_employee.task_page.button.stop': 'Stop',
    'ai_employee.task_page.button.retry': 'Retry',
    'ai_employee.task_page.error.turn_failed': 'Something went wrong and your message was not answered.',
    'ai_employee.task_page.badge.stopped': 'Stopped',
    'ai_employee.task_page.badge.failed': 'Failed',

    // Sections introduced by the AI Workforce UX pass — detail page
    // re-organisation. `tools` and `roles` headline the two main read panels;
    // `profile` and `agent_config` are the slide-out edit groupings.
    'ai_employee.section.profile': 'Profile',
    'ai_employee.section.agent_config': 'Agent Configuration',
    'ai_employee.section.roles': 'Roles',
    'ai_employee.section.tools': 'Tools',

    'ai_employee.id': 'ID',
    'ai_employee.name': 'Name',
    'ai_employee.priority': 'Priority',
    'ai_employee.task_type': 'Task Type',

    'ai_employee.label.n_permissions': '0 permissions | 1 permission | {count} permissions',

    'ai_employee.placeholder.search_tools': 'Search tools',

    'ai_employee.empty.no_tools': 'No tools available. Assign a role to grant tools.',

    'ai_employee.menu.cancel_selection': 'Cancel selection',

    'ai_employee.status.archived': 'Archived',
    'ai_employee.status.paused': 'Paused',

    // Cancel-task confirmation slide-out
    'ai_employee.confirm.cancel_task_title': 'Cancel Task',
    'ai_employee.confirm.cancel_task_warning': 'Cancelling will stop the task. In-progress work cannot be resumed.',
    'ai_employee.confirm.cancel_task_reason': 'Reason (optional)',
    'ai_employee.confirm.cancel_task_reason_placeholder': 'Why are you cancelling this task?',
    'ai_employee.confirm.cancel_task_keep_running': 'Keep Running',
    'ai_employee.confirm.cancel_task_confirm': 'Cancel Task',

    // Execution type & recurrence — used by the Run Settings section of
    // TaskApprovalSlideOut.
    'ai_employee.execution_type.immediate': 'Immediate',
    'ai_employee.execution_type.scheduled': 'Scheduled',
    'ai_employee.execution_type.recurring': 'Recurring',
    'ai_employee.recurrence.daily': 'Daily',
    'ai_employee.recurrence.weekly': 'Weekly',
    'ai_employee.recurrence.monthly': 'Monthly',

    // Task fields (surfaced in detail view + approval slide-out)
    'ai_employee.task.label': 'Task',
    'ai_employee.task.assign_to': 'Assigned To',
    'ai_employee.task.execution_type': 'Execution Type',
    'ai_employee.task.scheduled_at': 'Scheduled At',
    'ai_employee.task.recurrence_pattern': 'Recurrence',
    'ai_employee.task.error': 'Error',
    'ai_employee.button.new_task': 'New task',
    'ai_employee.task_page.button.discard_draft': 'Discard draft',
    'ai_employee.task_page.button.edit': 'Edit',
    'ai_employee.task_page.title.new_task': 'New AI task — Draft',
    'ai_employee.task_page.title.untitled': 'Untitled task',
    'ai_employee.start_task.header': 'Start a new AI task',
    'ai_employee.start_task.header_with_employee': 'Start a task for {name}',
    'ai_employee.start_task.subtitle': 'Pick an AI Employee to chat with. You can optionally seed the conversation with a working title and a brief.',
    'ai_employee.start_task.title_label': 'Working title (optional)',
    'ai_employee.start_task.title_placeholder': 'e.g. Reconcile May Stripe payouts',
    'ai_employee.start_task.title_help': 'Leave blank and the AI will suggest one when the plan is approved.',
    'ai_employee.start_task.brief_label': 'Initial brief (optional)',
    'ai_employee.start_task.brief_placeholder': 'Describe what you want the AI Employee to work on.',
    'ai_employee.start_task.brief_help': 'Sent as your first chat message so the AI can start drafting a plan right away.',
    'ai_employee.start_task.submit_button': 'Start task',
    'ai_employee.task_page.state.saving_draft': 'Saving draft…',
    'ai_employee.task_page.conversation.empty_planning': 'Send a message to start shaping this task with the AI Employee.',
    'ai_employee.task_page.conversation.readonly_notice': 'This conversation is read-only. Click Edit to revert this task to a draft if you need to refine the plan.',
    'ai_employee.task_page.tab.plan': 'Plan',
    'ai_employee.task_page.tab.logs': 'Logs',
    'ai_employee.task_page.tab.conversation': 'Conversation',
    'ai_employee.task_page.label.next_run': 'Next run',
    'ai_employee.task_page.label.next_run_immediate': 'As soon as picked up',
    'ai_employee.task_page.label.approved_at': 'Approved at',
    'ai_employee.task_page.label.approved_plan': 'Approved plan',
    'ai_employee.task_page.label.final_instructions': 'Final instructions',
    'ai_employee.modal.task_approval.section.run_settings': 'Run settings',
    'ai_employee.modal.task_approval.label.title_optional': 'Title (optional — AI will suggest)',
    'ai_employee.modal.task_approval.label.final_instructions': 'Final instructions',
    'ai_employee.modal.task_approval.label.inputs_json': 'Inputs (JSON, optional)',
    'ai_employee.modal.task_approval.placeholder.title_ai_suggestion': 'Leave blank to let the AI suggest a title',
    'ai_employee.modal.task_approval.placeholder.final_instructions': 'Polish the plan summary before it ships to the agent.',
    'ai_employee.modal.task_approval.placeholder.inputs_json': '{ "key": "value" }',
    'ai_employee.success.message.draft_discarded': 'Draft discarded.',
    'ai_employee.error.message.create_draft_failed': 'Failed to start a new task draft.',
    'ai_employee.error.message.revert_to_draft_failed': 'Failed to send this task back to draft.',

    // Task validation
    'ai_employee.validation.invalid_json': 'Inputs must be a valid JSON object.',

    // Misc messages surfaced after the UX pass
    'ai_employee.success.message.ai_employee_archived': 'AI Employee archived.',
    'ai_employee.error.message.archive_failed': 'Failed to archive AI Employee.',
    'ai_employee.error.message.update_failed': 'Failed to update AI Employee.',
    'ai_employee.error.message.loading_tasks': 'Failed to load tasks.',
    'ai_employee.error.message.load_permissions_failed': 'Failed to load permissions.',

    // AI Employee detail page tabs (gap-fix pass)
    'ai_employee.tab.overview': 'Overview',
    'ai_employee.tab.tasks': 'Tasks',
    'ai_employee.tab.activity': 'Activity',
    'ai_employee.tab.audit_log': 'Audit log',
    'ai_employee.empty.no_audit_log': 'Audit log not yet available.',
    'ai_employee.empty.no_activity': 'No recent activity.',

    // TaskApprovalSlideOut — tool pills, estimates grid, reject / request-changes
    'ai_employee.modal.task_approval.section.tools': 'Tools to be invoked',
    'ai_employee.modal.task_approval.section.estimates': 'Estimates',
    'ai_employee.modal.task_approval.estimate.tokens': 'Est. tokens',
    'ai_employee.modal.task_approval.estimate.tool_calls': 'Est. tool calls',
    'ai_employee.modal.task_approval.estimate.duration': 'Est. duration',
    'ai_employee.modal.task_approval.button.reject': 'Reject task',
    'ai_employee.modal.task_approval.button.request_changes': 'Request changes',

    // ConfirmCancelTaskSlideOut — header subtitle + metadata
    'ai_employee.confirm.cancel_task_subtitle': 'Cancelling will stop the streaming response and mark the task CANCELLED. History is preserved.',
    'ai_employee.confirm.started_relative': 'started {time}',
    'ai_employee.confirm.messages_count': '0 messages | 1 message | {count} messages',

    // Relative time (ConfirmCancelTaskSlideOut metadata)
    'ai_employee.relative.just_now': 'just now',
    'ai_employee.relative.minutes_ago': '{count}m ago',
    'ai_employee.relative.hours_ago': '{count}h ago',
    'ai_employee.relative.days_ago': '{count}d ago',

    // Task list fallbacks
    'ai_employee.task.unassigned': 'Unassigned',
    'ai_employee.task.untitled_numbered': 'Task #{id}',
};